import { axiosRequest } from "helpers";

export const documentsService = {
	getDocuments,
	addDocument,
	deleteDocument,
	submitPreApplication,
	viewDocument,
	downloadDocument,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

// used in DocumentsTable
function getDocuments(applicationId, { page }, sortBy) {
	return axiosRequest({
		url: `${API_URL}/api/pre_applications/${applicationId}/documents`,
		params: {
			ascending: sortBy?.desc,
			sort_type: sortBy?.id,
			page_index: page,
			page_size: PAGE_SIZE,
		},
	});
}

function addDocument(applicationId, document) {
	let formData = new FormData();
	let file = document.file;

	formData.append("file", file);
	formData.append("name", document.name);
	formData.append("extension", file.name.split(/[.]+/).pop());
	formData.append("type", document.type);

	const options = {
		headers: {
			"Content-Type": "multipart/form-data",
		},
		method: "POST",
		data: formData,
		url: `${API_URL}/api/pre_applications/${applicationId}/documents`,
	};

	return axiosRequest(options);
}

function deleteDocument(applicationId, documentId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/pre_applications/${applicationId}/documents/${documentId}`,
	};

	return axiosRequest(options);
}

function submitPreApplication(token, applicationId) {
	const options = {
		method: "POST",
		params: {
			token,
		},
		url: `${API_URL}/api/pre_applications/${applicationId}/submit`,
	};
	return axiosRequest(options);
}

async function viewDocument(applicationId, documentId) {
	try {
		window.open(
			`${API_URL}/api/pre_applications/${applicationId}/documents/${documentId}/content`,
			"_blank",
		);
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function downloadDocument(applicationId, documentId) {
	try {
		const url = `${API_URL}/api/pre_applications/${applicationId}/documents/${documentId}/content?download=true`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}
